import { Flex, Text } from "@fluentui/react-northstar";
import React from "react";

import { useTeamsContext } from "../state/TeamsContextProvider";
import { PollyDialog } from "./PollyDialog";
import { PollyIcon } from "./PollyIcon";

type Props = {
  exportResult?: string;
  exportSuccess?: boolean;
  onCancel: () => void;
};
export const ResultsExportCompletionDialog: React.FC<Props> = ({
  onCancel,
  exportResult,
  exportSuccess,
}) => {
  const { teamsContext } = useTeamsContext();
  return (
    <>
      {teamsContext.app.host.clientType !== "web" && exportSuccess && (
        <PollyDialog
          open
          onCancel={() => onCancel()}
          header={<PollyIcon icon="download-icon" inheritColor label="Export Complete" />}
        >
          <Flex column hAlign="center">
            <Text
              size={teamsContext.page.frameContext === "sidePanel" ? "small" : "large"}
              styles={{ marginTop: "1rem" }}
              content={
                <span>
                  The file was saved to the downloads folder on your computer as
                  <pre>{exportResult}</pre>
                </span>
              }
            />
          </Flex>
        </PollyDialog>
      )}
      {exportSuccess === false && (
        <PollyDialog
          open
          onCancel={() => onCancel()}
          header={<PollyIcon icon="download-icon" inheritColor label="Export Failed" />}
        >
          <Flex column hAlign="center">
            <Text
              size={teamsContext.page.frameContext === "sidePanel" ? "small" : "large"}
              styles={{ marginTop: "1rem", color: "red" }}
              content={
                <span>
                  Error occurred while exporting results.
                  <br /> {exportResult}
                </span>
              }
            />
          </Flex>
        </PollyDialog>
      )}
    </>
  );
};
